// The fee test on the phone: the server says whether it's on, the phone works out its own group.
import { FEE_MIN_TABLE, FEE_OFF, feeGroupFor, feeLine, friendFeeCents, type FeeConfig, type FeeGroup } from '../experiments.ts';
import { deviceIdNow } from './track.ts';

/**
 * `cardsKey` is Stripe's publishable key, set once cards and sign-in by text are both live.
 * `pricing` is the server's pricing switch (src/pricing.ts): off until the server says it's on, so
 * nothing about fees or splits with no fee shows while it's off.
 */
export const fee: { cfg: FeeConfig; cardsKey: string; pricing: boolean } = { cfg: FEE_OFF, cardsKey: '', pricing: false };

/** This phone's fee group, or null when the test is off. */
export const myFeeGroup = (): FeeGroup | null => feeGroupFor(fee.cfg, deviceIdNow());

/** What the payer sees on the tip step about the fee, for a table this size. Empty when there's no fee. */
export function payerFeeNote(partySize: number): string {
  const g = myFeeGroup();
  if (!g) return '';
  if (partySize < FEE_MIN_TABLE) return 'No fee for tables of 2.';
  return feeLine(g, fee.cfg.cents, g === 'C' ? friendFeeCents({ group: g, cents: fee.cfg.cents }, partySize, 1) : undefined);
}

/** The price line on landing pages, matching what this phone will see when it splits. */
export function landingFeeLine(): string {
  const g = myFeeGroup();
  return g ? feeLine(g, fee.cfg.cents) : '';
}
